import { CityItemSchema } from "./getCurrentCity";
import { setInstanceByEnvType } from "src/utils/helpers/requestApi/isServer";

export const checkCitySlug = (citySlug: string) =>
  setInstanceByEnvType().get<CityItemSchema>("/geo/cities/" + citySlug);
